import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"

import { Button, Modal } from "components"
import { deleteAllOrderItems } from "@redux"
import classes from "./KcWelcomeLayerPrompt.module.scss"

const KcWelcomeLayerPrompt = (props) => {
  const {
    setShowLayer,
    openPromptModal,
    setOpenPromptModal
  } = props

  const dispatch = useDispatch()

  const [t] = useTranslation()

  const history = useHistory()

  const handleContinue = () => {
    setOpenPromptModal(false)

    setShowLayer(false)
  }

  const handleReset = () => {
    dispatch(
      deleteAllOrderItems()
    )

    history.push("/kiosk-languages")

    setOpenPromptModal(false)

    setShowLayer(false)
  }

  return (
    <Modal
      show={openPromptModal}
      onHide={() => setOpenPromptModal(false)}
    >
      <div className={classes["container"]}>
        <Button
          color="success"
          className={classes["button"]}
          onClick={handleContinue}
        >
          {t("ادامه سفارش دهی")}
        </Button>

        <Button
          color="danger"
          onClick={handleReset}
        >
          {t("بازگشت به صفحه اصلی")}
        </Button>
      </div>
    </Modal>
  )
}

export default KcWelcomeLayerPrompt